'use client'

import { useState } from 'react'
import { formatNumber } from '@/lib/utils/format'

interface ForkButtonProps {
  promptId: string
  isOwner: boolean
  forkCount: number
  onFork: () => void
}

export function ForkButton({ isOwner, forkCount, onFork }: ForkButtonProps) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <button
      type="button"
      onClick={onFork}
      disabled={isOwner}
      // FORK-OWN: a visible reason for the disabled state (aria-label alone
      // wasn't surfaced to sighted mouse users).
      title={isOwner ? "You can't fork your own prompt; use Edit" : undefined}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="group flex items-center gap-1.5 rounded-[var(--radius-md)] border border-[var(--color-border-default)] px-3 py-1.5 text-[var(--text-sm)] transition-colors hover:border-[var(--color-brand-indigo)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-brand-indigo)] disabled:cursor-not-allowed disabled:opacity-50"
      aria-label={
        isOwner
          ? 'Cannot fork your own prompt'
          : `Fork prompt, ${forkCount} ${forkCount === 1 ? 'fork' : 'forks'}`
      }
    >
      <svg
        className="h-4 w-4 transition-colors"
        viewBox="0 0 24 24"
        fill="none"
        stroke={isHovered && !isOwner ? 'var(--color-brand-indigo)' : 'var(--color-text-secondary)'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="18" r="3" />
        <circle cx="6" cy="6" r="3" />
        <circle cx="18" cy="6" r="3" />
        <path d="M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9" />
        <path d="M12 12v3" />
      </svg>
      <span className="text-[var(--color-text-secondary)]">Fork</span>
      <span
        className="min-w-[1.5rem] text-center tabular-nums text-[var(--color-text-muted)]"
        aria-hidden="true"
      >
        {formatNumber(forkCount)}
      </span>
    </button>
  )
}
